import*as t from"react";import s from"classnames";import{BaseButton as p}from"./_internal/base-button.js";const o=t.forwardRef(({className:e,...n},r)=>t.createElement(p,{...n,ref:r,className:s("rt-Button",e)}));o.displayName="Button";export{o as Button};
//# sourceMappingURL=button.js.map
